/* Three steps 

1. Collect the customer information and store that 
2. Display the form for the customer to sign OR print
3. Update the request and store the doc in S3 (for electronic) or update status (for print)

The requestId should be passed in as a parameter with the request id

Read the request information and the vehicle information and the services but read the retail prices for them
not the wholesale prices
Read the Installer information as well

*/

// This will be the header unit for the wizard layout.

import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import CustomerForm from './../../customerForm';
import ViewContract from './displayContract';
import { HTTPService } from "./../../../services/httpService";
import ReactGA from 'react-ga4';
import axios from 'axios';
import _ from 'lodash';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const API = new HTTPService();

require('dotenv').config();

class ContractForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      currentStep: 1,
      customer: "",
      selectedRequest: "",
      vehicle: "",
      services: [],
      dealerships : [],
      dealer : {
        dealerName : "Steve Dealer",
        dealerAddress : "Glenwood"
      },
      installer : {
        installerName : "Dave Installer",
        installerEmail : "Westgate",
        services : "retail"
      },
      loading: false,
      user: this.props.user,
      show : false,
      signed : false,
      contractAction: null, // 'electronic' or 'print'
      contractCompleted: false
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleCustomer = this.handleCustomer.bind(this);
    this.handleElectronicSignature = this.handleElectronicSignature.bind(this);
    this.handlePrintContract = this.handlePrintContract.bind(this);
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
  }

async componentDidMount() {
  try {
    // Check if we have a requestId from the URL params
    const requestId = this.props.match.params.requestId;
    
    if (!requestId) {
      console.error("No request ID provided in URL");
      alert("Invalid contract request. Redirecting back to requests.");
      this.props.history.push("/requestimates");
      return;
    }

    console.log("Creating contract for request:", requestId);
    
    // Read the request information - using existing endpoint
    let dispRequest = `/requestimates/fullrequest/?Id=${requestId}`;        
    const { data: selectedRequests } = await API.get(dispRequest);
    
    if (!selectedRequests || selectedRequests.length === 0) {
      console.error("No request found for ID:", requestId);
      alert("Request not found. Redirecting back to requests.");
      this.props.history.push("/requestimates");
      return;
    }
    
    const selectedRequest = selectedRequests[0];
    
    // Verify this is a dealer request and user has permission
    if (selectedRequest.requestType !== 'dealer') {
      alert("Contracts can only be created for dealer requests.");
      this.props.history.push("/requestimates");
      return;
    }
    
    // Check if request has an assigned specialist
    if (!selectedRequest.assignedTo || selectedRequest.assignedTo === 0) {
      alert("A specialist must be assigned before creating a contract.");
      this.props.history.push("/requestimates");
      return;
    }

    // Get retail services for the contract (using existing logic)
    let svcRequest = `/requestService/${requestId}`;        
    const { data: services } = await API.get(svcRequest);

    // Get installer information (using existing logic)
    let installerRequest = `/installers/${selectedRequest.assignedTo}`;        
    const { data: installers } = await API.get(installerRequest);
    installers[0].services = "retail"; // Set to retail for contract pricing

    // Get dealer information (using existing logic)
    let dealRequest = `/dealers/${selectedRequest.requestor}`;        
    const { data: dealers } = await API.get(dealRequest);

    // Create vehicle object from request data
    const vehicle = {
      vin: selectedRequest.vin || 'Not Available',
      year: selectedRequest.vehicleYear,
      make: selectedRequest.vehicleMake,
      model: selectedRequest.vehicleModel,
      trim: selectedRequest.vehicleTrim
    };

    // Batch all state updates
    this.setState({
      selectedRequest: selectedRequest,
      services: services,
      installer: installers[0],
      dealer: dealers[0],
      vehicle: vehicle
    });
    
  } catch (error) {
    console.error("Error in ContractForm componentDidMount:", error);
    alert("Error loading contract data. Please try again.");
    this.props.history.push("/requestimates");
  }
};
  // Add request state using existing server-side function
  addRequestState = async (requestId, requeststate, requestService) => {
    // Format date as "YYYY-MM-DD HH:MM:SS"
    const now = new Date();
    const formattedDate = now.getFullYear() + '-' + 
      String(now.getMonth() + 1).padStart(2, '0') + '-' + 
      String(now.getDate()).padStart(2, '0') + ' ' + 
      String(now.getHours()).padStart(2, '0') + ':' + 
      String(now.getMinutes()).padStart(2, '0') + ':' + 
      String(now.getSeconds()).padStart(2, '0');

    const state = {
      requestId: requestId,
      stateDate: formattedDate,
      requestStatus: requeststate,
      serviceId: requestService,
    };

    const apiEndpoint = `/requestState`;
    await API.post(apiEndpoint, state);
    return null;
  };

// Updated generateContractPDF method to use dealer's retail pricing
  generateContractPDF = async (signatureData = null, manualSignatureDate = null) => {
    // Create a temporary hidden div with the contract content
    const tempContractDiv = document.createElement('div');
    tempContractDiv.id = 'temp-contract-for-pdf';
    tempContractDiv.style.position = 'absolute';
    tempContractDiv.style.left = '-9999px';
    tempContractDiv.style.top = '-9999px';
    tempContractDiv.style.width = '800px';
    tempContractDiv.style.backgroundColor = 'white';
    tempContractDiv.style.padding = '20px';

    // Build the contract data
    const contractData = {
      customerName: this.state.customer?.customer_name || 'N/A',
      customerAddress: this.state.customer?.customer_address || 'N/A',
      customerEmail: this.state.customer?.customer_Email_Address || 'N/A',
      vehicleYear: this.state.selectedRequest?.vehicleYear || 'N/A',
      vehicleMake: this.state.selectedRequest?.vehicleMake || 'N/A',
      vehicleModel: this.state.selectedRequest?.vehicleModel || 'N/A',
      vehicleTrim: this.state.selectedRequest?.vehicleTrim || 'N/A',
      vin: this.state.vehicle?.vin || this.state.selectedRequest?.vin || 'N/A',
      dealerName: this.state.dealer?.dealer_name || 'N/A',
      dealerAddress: `${this.state.dealer?.dealer_address_line1 || ''}, ${this.state.dealer?.dealer_address_city || ''}, ${this.state.dealer?.dealer_address_state || ''} ${this.state.dealer?.dealer_address_zip || ''}`,
      installerName: this.state.installer?.Installer_Name || 'N/A',
      installerEmail: this.state.installer?.installer_email || 'N/A',
      date: new Date().toLocaleDateString(),
    };

    // Generate services table HTML using dealer's retail pricing
    let servicesTableHTML = `
      <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
        <thead>
          <tr>
            <th style="background-color: #4a90e2; color: white; padding: 6px; font-size: 10px; text-align: left;">Category</th>
            <th style="background-color: #4a90e2; color: white; padding: 6px; font-size: 10px; text-align: left;">Service</th>
            <th style="background-color: #4a90e2; color: white; padding: 6px; font-size: 10px; text-align: left;">Amount</th>
          </tr>
        </thead>
        <tbody>`;
    
    let totalAmount = 0;
    if (this.state.services && this.state.services.length > 0) {
      this.state.services.forEach((service, index) => {
        // Use retail_price if available (dealer's override), otherwise fall back to service_cost
        const cost = parseFloat(service.retail_price || service.service_cost);
        const amount = isNaN(cost) ? "$0.00" : "$" + cost.toFixed(2);
        totalAmount += isNaN(cost) ? 0 : cost;
        
        servicesTableHTML += `
          <tr>
            <td style="padding: 6px; border-bottom: 1px solid #ddd;">${service.service_category || 'N/A'}</td>
            <td style="padding: 6px; border-bottom: 1px solid #ddd;">${service.description || 'N/A'}</td>
            <td style="padding: 6px; border-bottom: 1px solid #ddd; text-align: right; font-weight: bold; color: #28a745;">${amount}</td>
          </tr>`;
      });
    } else {
      servicesTableHTML += '<tr><td colspan="3" style="padding: 6px; border-bottom: 1px solid #ddd; text-align: center;">No services selected</td></tr>';
    }
    servicesTableHTML += '</tbody></table>';

    // Create signature section based on type
    let signatureSection = '';
    if (signatureData) {
      // Electronic signature - embed signature image with date
      const signatureDate = new Date().toLocaleDateString();
      signatureSection = `
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-top: 15px; border-top: 2px solid #333; padding-top: 10px;">
          <div style="text-align: center;">
            <div><strong>Customer Signature:</strong></div>
            <img src="${signatureData}" style="max-width: 180px; max-height: 50px; border: 1px solid #ccc; margin: 5px 0;" alt="Customer Signature" />
            <div style="font-size: 11px;">${contractData.customerName}</div>
          </div>
          <div style="text-align: center;">
            <div><strong>Date:</strong></div>
            <div style="border-bottom: 1px solid #333; height: 30px; margin: 5px 0; padding-top: 10px; font-size: 11px;">${signatureDate}</div>
          </div>
        </div>
      `;
    } else if (manualSignatureDate) {
      // Manual signature - populate customer name and date
      const formattedDate = new Date(manualSignatureDate).toLocaleDateString();
      signatureSection = `
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-top: 15px; border-top: 2px solid #333; padding-top: 10px;">
          <div style="text-align: center;">
            <div><strong>Customer Signature:</strong></div>
            <div style="border-bottom: 1px solid #333; height: 30px; margin: 5px 0; padding-top: 10px; font-size: 11px;">${contractData.customerName}</div>
          </div>
          <div style="text-align: center;">
            <div><strong>Date:</strong></div>
            <div style="border-bottom: 1px solid #333; height: 30px; margin: 5px 0; padding-top: 10px; font-size: 11px;">${formattedDate}</div>
          </div>
        </div>
      `;
    } else {
      // Blank signature line for manual printing
      signatureSection = `
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-top: 15px; border-top: 2px solid #333; padding-top: 10px;">
          <div style="text-align: center;">
            <div style="font-weight: bold;">Customer Signature:</div>
            <div style="border-bottom: 1px solid #333; height: 30px; margin: 5px 0;"></div>
            <div style="font-size: 11px;">${contractData.customerName}</div>
          </div>
          <div style="text-align: center;">
            <div style="font-weight: bold;">Date:</div>
            <div style="border-bottom: 1px solid #333; height: 30px; margin: 5px 0;"></div>
          </div>
        </div>
      `;
    }

    // Create the compressed single-page contract HTML
    tempContractDiv.innerHTML = `
      <div style="font-family: Arial, sans-serif; font-size: 11px; line-height: 1.3; color: #333;">
        <div style="text-align: center; font-size: 16px; font-weight: bold; margin-bottom: 15px; color: #2c5aa0;">
          Paint Protection Film & Window Tint Purchase Agreement
        </div>
        <div style="text-align: center; font-size: 12px; margin-bottom: 20px;">
          Agreement Date: ${contractData.date}
        </div>
        
        <!-- Customer and Vehicle Info Grid -->
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
          <div style="background-color: #f8f9fa; padding: 8px; border-left: 3px solid #4a90e2;">
            <div style="background-color: #4a90e2; color: white; padding: 4px 8px; font-weight: bold; font-size: 10px; text-transform: uppercase; margin-bottom: 6px;">Customer Information</div>
            <div style="margin-bottom: 3px;"><span style="font-weight: bold; display: inline-block; width: 60px;">Name:</span> ${contractData.customerName}</div>
            <div><span style="font-weight: bold; display: inline-block; width: 60px;">Email:</span> ${contractData.customerEmail}</div>
          </div>
          
          <div style="background-color: #f8f9fa; padding: 8px; border-left: 3px solid #4a90e2;">
            <div style="background-color: #4a90e2; color: white; padding: 4px 8px; font-weight: bold; font-size: 10px; text-transform: uppercase; margin-bottom: 6px;">Vehicle Information</div>
            <div style="margin-bottom: 3px;"><span style="font-weight: bold; display: inline-block; width: 60px;">Year:</span> ${contractData.vehicleYear} | <span style="font-weight: bold;">Make:</span> ${contractData.vehicleMake}</div>
            <div style="margin-bottom: 3px;"><span style="font-weight: bold; display: inline-block; width: 60px;">Model:</span> ${contractData.vehicleModel} | <span style="font-weight: bold;">Trim:</span> ${contractData.vehicleTrim}</div>
            ${contractData.vin && !contractData.vin.startsWith('NV') && contractData.vin !== 'N/A' ? `<div><span style="font-weight: bold; display: inline-block; width: 60px;">VIN:</span> ${contractData.vin}</div>` : ''}
          </div>
        </div>

        <!-- Dealer and Installer Info Grid -->
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 15px;">
          <div style="background-color: #f8f9fa; padding: 8px; border-left: 3px solid #4a90e2;">
            <div style="background-color: #4a90e2; color: white; padding: 4px 8px; font-weight: bold; font-size: 10px; text-transform: uppercase; margin-bottom: 6px;">Dealer Information</div>
            <div style="margin-bottom: 3px;"><span style="font-weight: bold; display: inline-block; width: 60px;">Name:</span> ${contractData.dealerName}</div>
            <div><span style="font-weight: bold; display: inline-block; width: 60px;">Address:</span> ${contractData.dealerAddress}</div>
          </div>
          
          <div style="background-color: #f8f9fa; padding: 8px; border-left: 3px solid #4a90e2;">
            <div style="background-color: #4a90e2; color: white; padding: 4px 8px; font-weight: bold; font-size: 10px; text-transform: uppercase; margin-bottom: 6px;">Certified Installer</div>
            <div style="margin-bottom: 3px;"><span style="font-weight: bold; display: inline-block; width: 60px;">Name:</span> ${contractData.installerName}</div>
            <div><span style="font-weight: bold; display: inline-block; width: 60px;">Email:</span> ${contractData.installerEmail}</div>
          </div>
        </div>

        <!-- Services Section -->
        <div style="margin-bottom: 12px;">
          <div style="background-color: #4a90e2; color: white; padding: 4px 8px; font-weight: bold; font-size: 10px; text-transform: uppercase; margin-bottom: 6px;">Purchased Services</div>
          ${servicesTableHTML}
        </div>

        <!-- Terms Section -->
        <div style="margin-bottom: 12px;">
          <div style="background-color: #4a90e2; color: white; padding: 4px 8px; font-weight: bold; font-size: 10px; text-transform: uppercase; margin-bottom: 6px;">Terms and Conditions</div>
          <div style="font-size: 9px; line-height: 1.2; background-color: #f8f9fa; padding: 8px; border: 1px solid #ddd;">
            <strong>Professional Installation:</strong> The dealership utilizes ${contractData.installerName} as a professional installer to complete the work. The performance of the installation will adhere to industry standards. | <strong>Issue Resolution:</strong> Any concerns or issues regarding the work performed should be addressed in-writing by contacting the installer directly via email at: ${contractData.installerEmail}. Customers are encouraged to schedule a consultation for any installation-related inquiries. | <strong>Limitation of Liability:</strong> The dealership shall not be held liable for any issues arising from the installation of the package.
          </div>
        </div>

        <!-- Signature Section -->
        ${signatureSection}
      </div>
    `;

    // Add to DOM temporarily
    document.body.appendChild(tempContractDiv);

    try {
      // Generate the canvas from the temporary div
      const canvas = await html2canvas(tempContractDiv, { 
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false
      });
      
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      
      // Calculate dimensions to fit the page
      const imgWidth = 190; // A4 width minus margins
      const pageHeight = 277; // A4 height minus margins
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 10;

      // Add first page
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Add additional pages if needed (though this design should fit on one page)
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight + 10;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      return pdf;
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error;
    } finally {
      // Clean up - remove the temporary div
      if (document.body.contains(tempContractDiv)) {
        document.body.removeChild(tempContractDiv);
      }
    }
  };

  // Handle electronic signature option
  handleElectronicSignature = async (signatureData) => {
    this.setState({ loading: true, contractAction: 'electronic' });

    try {
      // Generate PDF with embedded signature
      const pdf = await this.generateContractPDF(signatureData);
      const pdfBlob = pdf.output("blob");

      const formData = new FormData();
      formData.append("file", pdfBlob, `contract_${this.state.selectedRequest.requestId}.pdf`);
      formData.append("requestId", this.state.selectedRequest.requestId);
      formData.append("customerId", this.state.customerId);
      formData.append("dealerEmail", this.props.user.Email);
      formData.append("customerEmail", this.state.customer.customer_Email_Address);
      formData.append("signatureMethod", "electronic");

      // Upload signed contract to S3
      await axios.post("uploadContract", formData, {
        baseURL: process.env.REACT_APP_API_URL,  
      });

      // Log state change using existing function
      await this.addRequestState(
        this.state.selectedRequest.requestId, 
        'CONTRACT_SIGNED_ELECTRONIC',
        null // no specific service ID
      );

      this.setState({ 
        signed: true, 
        contractCompleted: true,
        loading: false 
      });

      ReactGA.event({
        category: 'Contract', 
        action: 'Electronic Signature Complete', 
        label: 'prod'
      });

      alert("Contract signed electronically! Copies have been emailed to all parties and the specialist has been notified.");

    } catch (error) {
      console.error("Electronic signature failed:", error);
      this.setState({ loading: false });
      alert("Failed to process electronic signature. Please try again.");
    }
  };

  // Add this simple function to the ContractForm class

// Handle manual signature completion - just log to audit trail
handleManualSignatureComplete = async () => {
  this.setState({ loading: true });

  try {
    // Log manual signature completion to audit trail
    await this.addRequestState(
      this.state.selectedRequest.requestId, 
      'CONTRACT_SIGNED_MANUAL',
      null
    );

    this.setState({ 
      signed: true, 
      contractCompleted: true,
      loading: false 
    });

    ReactGA.event({
      category: 'Contract', 
      action: 'Manual Signature Complete', 
      label: 'prod'
    });

    // Auto-redirect after brief success message
    alert("Manual signature recorded successfully!");
    setTimeout(() => {
      window.location = "/requestimates";
    }, 500);

  } catch (error) {
    console.error("Failed to record manual signature:", error);
    this.setState({ loading: false });
    alert("Failed to record manual signature. Please try again.");
  }
};

  // Handle print contract option - UPDATED with S3 storage
  handlePrintContract = async () => {
    this.setState({ loading: true, contractAction: 'print' });

    try {
      // Generate PDF for printing
      const pdf = await this.generateContractPDF();
      const pdfBlob = pdf.output("blob");
      
      // === NEW: Save contract to S3 before download ===
      const formData = new FormData();
      formData.append("file", pdfBlob, `contract_${this.state.selectedRequest.requestId}.pdf`);
      formData.append("requestId", this.state.selectedRequest.requestId);
      formData.append("customerId", this.state.customerId);
      formData.append("dealerEmail", this.props.user.Email);
      formData.append("customerEmail", this.state.customer.customer_Email_Address);
      formData.append("signatureMethod", "manual");

      // Upload contract to S3 for audit trail
      await axios.post("uploadContract", formData, {
        baseURL: process.env.REACT_APP_API_URL,  
      });
      
      // === EXISTING: Download for dealer ===
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `contract_${this.state.selectedRequest.requestId}.pdf`;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);

      // === EXISTING: Log state change ===
      await this.addRequestState(
        this.state.selectedRequest.requestId, 
        'CONTRACT_DOWNLOADED',
        null
      );

      this.setState({ 
        contractCompleted: true,
        loading: false 
      });

      ReactGA.event({
        category: 'Contract', 
        action: 'Contract Downloaded', 
        label: 'prod'
      });

      // === UPDATED: Better messaging ===
      alert("Contract has been saved to your account and downloaded for manual signature.");

    } catch (error) {
      console.error("Print contract failed:", error);
      this.setState({ loading: false });
      alert("Failed to generate contract for printing. Please try again.");
    }
  };


  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    })
  }

  handleCancel = e => {
    e.preventDefault();
    ReactGA.event({category: 'Dealer', action: 'Cancel Contract', label: 'prod'});
    this.props.history.push("/requestimates");
    return;
  }

  handleCustomer(customerId, customerName, customerType, customer) {
    this.setState({customer, customerId});
  }

  handleDisplay = () => {
    this.setState({show : true});
  }

  handleClose = () => {
    this.setState({show : false, loading : false});
  }
    
  _next() {
    let currentStep = this.state.currentStep
    // If the current step is 1, then add one on "next" button click
    currentStep = currentStep >= 2 ? 4 : currentStep + 1
    this.setState({ currentStep: currentStep })
  }

  _prev() {
    let currentStep = this.state.currentStep
    // If the current step is 2 or 3, then subtract one on "previous" button click
    currentStep = currentStep <= 1 ? 1 : currentStep - 1
    this.setState({ currentStep: currentStep })
  }

  // The "next" and "previous" button functions
  get previousButton() {
    let currentStep = this.state.currentStep;

    // If the current step is not 1, then render the "previous" button
    if (currentStep !== 1) {
      return (<button className="btn btn-success buttons" type="button" onClick={this._prev}> PREV</button>)
    }

    // ...else return nothing
    return null;
  }

get nextButton() {
  let currentStep = this.state.currentStep;
  
  if(currentStep < 2){
    // Step 1: Customer info collection
    let disable = true;
    if (currentStep === 1 && this.state.customer) {
      disable = false;
    }
    return (
      <button 
        className="btn btn-success float-right buttons" 
        type="button" disabled={disable} onClick={this._next}>
        NEXT
      </button>        
    )
  } else {
    // Step 2: Contract completion
    if (this.state.contractCompleted) {
      // Contract is fully completed - automatically redirect
      setTimeout(() => {
        window.location = "/requestimates";
      }, 1500);
      
      return (
        <div className="alert alert-success text-center">
          <i className="fa-solid fa-circle-check"></i> Contract completed successfully! Redirecting...
        </div>
      );
    } else if (this.state.contractAction === 'print') {
      // Contract was printed, waiting for manual signature confirmation
      return (
        <button 
          className="btn btn-warning float-right" 
          type="button" 
          onClick={() => this.handleManualSignatureComplete()}>
          {this.state.loading && <span>
            <i className="fa-solid fa-arrows-rotate fa-spin" />
          </span>}
          {!this.state.loading && <span>Signature Completed</span>}
        </button>
      );
    } else {
      // No action taken yet - user needs to sign electronically or print
      return null;
    }
  }
}

  // This is also where when all the validation is completed, we push the new record
  // and redirect the page to the requestimate form with the parameters set
 render() {
  return (
    <React.Fragment>
      <div className="bg-white border border-secondary">
        <div className="col-lg-12 text-right">
          <button className="btn" type="button" onClick={this.handleCancel}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        
        {/* ADD VEHICLE TITLE HERE - Only show on Step 1 (customer information step) */}
        {this.state.selectedRequest && this.state.currentStep === 1 && (
          <div className="col-lg-12 px-4 pb-3">
            <h4 className="text-center text-primary mb-4">
              {this.state.selectedRequest.vehicleYear} {this.state.selectedRequest.vehicleMake} {this.state.selectedRequest.vehicleModel}
              {this.state.selectedRequest.vehicleTrim && ` ${this.state.selectedRequest.vehicleTrim}`}
              {this.state.vehicle?.vin && this.state.vehicle.vin !== 'Not Available' && this.state.vehicle.vin.substring(0, 2) !== "NV" && (
                <div>
                  VIN: {this.state.vehicle.vin}
                </div>
              )}
            </h4>
          </div>
        )}
        
        <div className="col-lg-12 p-0">
          <CustomerForm 
            currentStep={this.state.currentStep} 
            userType="installer"
            vehicle={this.state.vehicle}
            availableDate={this.state.availableDate}
            dueDate={this.state.dueDate}
            services={this.state.services}
            notes={this.state.notes}
            dealerships={this.state.dealerships}
            handleCustomer={this.handleCustomer}
            installer={this.state.installer}
            mode={"add"}
          />       
          <ViewContract
            userType={this.props.userType}
            typeId={this.props.typeId}
            currentStep={this.state.currentStep} 
            customer={this.state.customer}
            request={this.state.selectedRequest}
            vehicle={this.state.vehicle || { vin: this.state.selectedRequest?.vin }}
            services={this.state.services}
            dealer={this.state.dealer}
            installer={this.state.installer}
            contract={this.state.contract}
            handleElectronicSignature={this.handleElectronicSignature}
            handleManualSignature={this.handleManualSignature}
            handlePrintContract={this.handlePrintContract}
            show={this.state.show}
            handleClose={this.handleClose}
            handleDisplay={this.handleDisplay}
            signed={this.state.signed}
            contractCompleted={this.state.contractCompleted}
            contractAction={this.state.contractAction}
            loading={this.state.loading}
          />

          <div className="m-5 d-flex justify-content-center">
            <div className="p-2">
              {this.previousButton}
            </div>
            <div className="p-2">
              {this.nextButton}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

};
export default withRouter(ContractForm);